module.exports = __webpack_public_path__ + "media/images/ui__arrowDown--dark-f7387a9d2f5915503251e703ccf10339.png";